import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import { createComponent, getComponentSize, getComponentVariant, dynamicAttributes } from '../utils';
import styled, { css } from 'styled-components';
export var tagVariants = ['blue', 'gray', 'gold', 'red', 'orange', 'green'];
var TagContainer = createComponent({
    name: 'TagContainer',
    tag: 'div',
    style: function (_a) {
        var variant = _a.variant, theme = _a.theme, styles = _a.styles;
        var sizeStyles = getComponentSize(theme, 'Tag', 'sm');
        var variantStyles = variant ? getComponentVariant(theme, 'Tag', variant) : '';
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: inline-block;\n      font-size: 14px;\n      font-weight: 700;\n      letter-spacing: 0.1px;\n      line-height: 18px;\n\n      ", "\n      ", "\n      ", "\n    "], ["\n      display: inline-block;\n      font-size: 14px;\n      font-weight: 700;\n      letter-spacing: 0.1px;\n      line-height: 18px;\n\n      ", "\n      ", "\n      ", "\n    "])), styles, variantStyles, sizeStyles);
    },
});
var TagInner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 2px;\n"], ["\n  margin-bottom: 2px;\n"])));
export var Tag = function (_a) {
    var variant = _a.variant, className = _a.className, children = _a.children, styles = _a.styles, _b = _a.dataQa, dataQa = _b === void 0 ? '' : _b;
    return (React.createElement(TagContainer, __assign({ styles: styles, variant: variant, className: className }, dynamicAttributes('data-qa', dataQa)),
        React.createElement(TagInner, null, children)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tag.js.map